import { MetaRating } from "@repo/shared/types";

export const findMetaRating = ({
  metaRatings,
  playerRoleId,
  chemistry,
  chemStyleId,
}: {
  metaRatings: MetaRating[];
  playerRoleId?: number;
  chemistry?: number;
  chemStyleId?: number;
}) => {
  // 0 is a real chemistry/chemstyle value, so filter on "was it passed", not truthiness.
  return metaRatings.find(
    (metaRating) =>
      (playerRoleId !== undefined
        ? metaRating.playerRoleId === playerRoleId
        : true) &&
      (chemistry !== undefined ? metaRating.chemistry === chemistry : true) &&
      (chemStyleId !== undefined
        ? metaRating.chemstyleId === chemStyleId
        : true),
  );
};
